module.exports = __webpack_public_path__ + "static/img/pic1.505d7b0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/pic1.jpeg
// module id = jUa7
// module chunks = 0